import type { ReactNode } from 'react';

interface AppointmentDetailFieldProps {
    label: string;
    hint?: string;
    children: ReactNode;
}

/** Read-only counterpart of the dashboard Composer's `Field` wrapper (see
 *  Composer.tsx) — same label treatment, no required marker (nothing here
 *  is editable). */
export function AppointmentDetailField({ label, hint, children }: AppointmentDetailFieldProps) {
    return (
        <div>
            <div className="text-xs font-medium uppercase tracking-wide text-gray-500 mb-1.5">
                {label}
            </div>
            {children}
            {hint && <div className="text-xs text-gray-400 mt-1.5">{hint}</div>}
        </div>
    );
}
